var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDesktopComputer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,58.75H39.25v2.5H26v1.5H54v-1.5H40.75v-2.5H68A2.7528,2.7528,0,0,0,70.75,56V22A2.7528,2.7528,0,0,0,68,19.25H12A2.7528,2.7528,0,0,0,9.25,22V56A2.7528,2.7528,0,0,0,12,58.75ZM10.75,22A1.25116,1.25116,0,0,1,12,20.75H68A1.25116,1.25116,0,0,1,69.25,22V51.25H10.75Zm0,30.75h58.5V56A1.25116,1.25116,0,0,1,68,57.25H12A1.25116,1.25116,0,0,1,10.75,56Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDesktopComputer);
export default __webpack_public_path__ + "static/media/icon_desktop_computer.bb6d41698b89bc32be8e253f9d483f75.svg";
export { ForwardRef as ReactComponent };